export default __webpack_public_path__ + "static/media/squares800.4e6bfb6f.jpg";